// extracted by css-extract-rspack-plugin
export default {"cell":"YcTTk"};